import { ENTERPRISE_ADLE_MODULE_VALUES } from "../../utils/constants";
import { ENTERPRISE_INTAKE_RELOCATED_FIELDS } from "./config/enterpriseIntakeModuleFieldRegistry";

const asString = (v) => (v == null ? "" : String(v));

const getRelocatedFieldsForModule = (moduleValue) =>
  Object.entries(ENTERPRISE_INTAKE_RELOCATED_FIELDS)
    .filter(([, module]) => module === moduleValue)
    .map(([field]) => field);

const hasFieldValue = (value) => {
  if (Array.isArray(value)) return value.length > 0;
  return Boolean(asString(value).trim());
};

export const isModuleSelected = ({ selectedModules, moduleValue }) =>
  Array.isArray(selectedModules) && selectedModules.includes(moduleValue);

export const isNonNegativeIntegerString = (val) => {
  const trimmed = asString(val).trim();
  if (!trimmed) return false;
  const num = parseInt(trimmed, 10);
  return !isNaN(num) && num >= 0 && String(num) === trimmed;
};

export const isOptionalNonNegativeIntegerString = (val) =>
  !asString(val).trim() || isNonNegativeIntegerString(val);

export const hasModuleFieldData = ({ formValues, fieldPrefix }) =>
  Object.entries(formValues ?? {}).some(([key, value]) => {
    if (!key.startsWith(fieldPrefix)) return false;
    if (Array.isArray(value)) return value.length > 0;
    return Boolean(asString(value).trim());
  });

export const shouldShowModuleCard = ({
  moduleValue,
  fieldPrefix,
  selectedModules,
  formValues,
  readOnly,
}) => {
  if (isModuleSelected({ selectedModules, moduleValue: moduleValue })) {
    return true;
  }
  if (readOnly) {
    if (hasModuleFieldData({ formValues, fieldPrefix })) return true;
    return getRelocatedFieldsForModule(moduleValue).some((field) =>
      hasFieldValue(formValues?.[field])
    );
  }
  return false;
};

export const MODULE_VALUE_TO_PREFIX = {
  [ENTERPRISE_ADLE_MODULE_VALUES.CREATIVE_ASSETS]: "module1",
  [ENTERPRISE_ADLE_MODULE_VALUES.PAID_MEDIA_LAUNCH]: "module2",
  [ENTERPRISE_ADLE_MODULE_VALUES.PAID_MEDIA_IMPORT]: "module3",
  [ENTERPRISE_ADLE_MODULE_VALUES.ORGANIC_SOCIAL]: "module4",
};

export const PEAK_DEMAND_VALUE = "peak_demand";
